import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  saving: false,
  config: null,
  error: null,
  saveError: null,
  saveMessage: null,
};

const ssoConfigSlice = createSlice({
  name: "ssoConfig",
  initialState,
  reducers: {
    fetchSsoConfig: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSsoConfigSuccess: (state, action) => {
      state.loading = false;
      state.config = action.payload;
      state.error = null;
    },
    fetchSsoConfigFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveSsoConfig: (state) => {
      state.saving = true;
      state.saveError = null;
      state.saveMessage = null;
    },
    saveSsoConfigSuccess: (state, action) => {
      state.saving = false;
      state.config = action.payload;
      state.saveError = null;
      state.saveMessage = "Single Sign-On configuration saved.";
    },
    saveSsoConfigFailure: (state, action) => {
      state.saving = false;
      state.saveError = action.payload;
    },
    clearSsoConfigMessages: (state) => {
      state.error = null;
      state.saveError = null;
      state.saveMessage = null;
    },
  },
});

export const {
  fetchSsoConfig,
  fetchSsoConfigSuccess,
  fetchSsoConfigFailure,
  saveSsoConfig,
  saveSsoConfigSuccess,
  saveSsoConfigFailure,
  clearSsoConfigMessages,
} = ssoConfigSlice.actions;

export default ssoConfigSlice.reducer;
